import { AppDatatableActivateEvent } from "../models";
import { Keys } from "@swimlane/ngx-datatable/release/utils";

export class AppDatatableEventsUtils {

    private static MAX_DEPTH: number = 5;

    private static CELL_CLASS: string = "datatable-body-cell";

    private static CELL_INPUT_SELECTOR: string = "input[app-datatable-events-cell-bubble]:not([readonly]):not([disabled])";

    public static findPreviousNextInputSibling(inputEl: any, cellElement: any): any {
        let siblings = {};
        if(cellElement) {
            let allSiblings: Array<Node> = cellElement.querySelectorAll(AppDatatableEventsUtils.CELL_INPUT_SELECTOR);
            allSiblings.forEach((value: Node, index: number, array: Array<Node>) => {
                if(value.isSameNode(inputEl)) {
                    if(index>0) {
                        siblings["previousSibling"] = allSiblings[index-1];
                    }
                    if(index+1<=array.length) {
                        siblings["nextSibling"] = allSiblings[index+1];
                    }
                    return siblings;
                }
            });
        }
        return siblings;
    }
    
    public static findParentCellElement(inputEl: any): any {
        let cnt = 1;
        let pEl = inputEl.parentElement;
        while(cnt<AppDatatableEventsUtils.MAX_DEPTH) {
            if(pEl.classList.contains(AppDatatableEventsUtils.CELL_CLASS)) {
                return pEl;
            } else {
                cnt++;
                pEl = pEl.parentElement;
            }
        }
        return false;
    }

    public static focusInputElementFromCellActivateEvent(event: AppDatatableActivateEvent) {
        //console.log(">> focusInputElementFromCellActivateEvent", event);
        if(event.cellElement) {
            let inputElements: Array<any> = event.cellElement.querySelectorAll(AppDatatableEventsUtils.CELL_INPUT_SELECTOR);
            if(inputElements && inputElements.length>1 && event.keyCode === Keys.up) {
                inputElements[inputElements.length-1].focus();
            } else if(inputElements && inputElements.length>0){
                inputElements[0].focus();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/directives/events.utils.ts